import { render, staticRenderFns } from "./template.vue?vue&type=template&id=64fb07a2&scoped=true"
var script = {}
import style0 from "./template.vue?vue&type=style&index=0&id=64fb07a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fb07a2",
  null
  
)

export default component.exports